import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GenericRepository } from "../generic-repository/GenericRepository";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { AccessRightsModel } from "src/app/models/AccessRight/access-right.model";
import { IUserShiftRepository } from "./IUserShiftRepository";
import { UserShiftModel } from "src/app/models/UserShift/user-shift.model";
import { ResponseModel } from "src/app/models/SharedModels/response.model";

@Injectable(
    {
        providedIn:"root"
    }
)
export class UserShiftRepository extends GenericRepository<UserShiftModel> implements IUserShiftRepository {
    
    url: string = environment.urlAddress; 
    
    constructor(protected _http: HttpClient) {
        super(_http, 'api/UserShift', environment.urlAddress);
    }

    SaveRec(item: UserShiftModel):Observable<any> {
        return this.PostData('/SaveRec',item).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
        filterText = filterText.split('/').join('~');
        if (filterText == "") {
            filterText = "|";
        }
        return this._http
            .get(this.url + 'api/UserShift/SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetSummaryList(shiftID: number): Observable<any> {
        return this._http
            .get(this.url + 'api/UserShift/GetShiftSummary' + '/' + shiftID, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError));
    }

}
